import { FC, useEffect, useState } from 'react';
import { Placement, PlacementStatus } from 'modules/placements/types';
import {
  serializationOptionsForNumberValue,
  useSearchParamState,
} from 'utils/hooks/useSearchParamState';
import { PlacementsManageContext, PlacementsManageContextState } from './PlacementsManageContext';
import { useQueryPlacements } from '../hooks/useQueryPlacements';

export const PlacementsManageContextProvider: FC<React.PropsWithChildren<unknown>> = ({
  children,
}) => {
  const [placementId] = useSearchParamState({
    searchParamKey: 'placementId',
    stateValueWhenSearchParamIsUnset: 0,
    pushChangesToBrowserHistory: true,
    ...serializationOptionsForNumberValue,
  });
  const { placements, loading: placementsLoading } = useQueryPlacements(false);
  const [selectedPlacement, setSelectedPlacement] = useState<Placement | undefined>(undefined);
  const [statusFilterTab, setStatusFilterTab] = useState<PlacementStatus>(PlacementStatus.ACTIVE);
  const [searchText, setSearchText] = useState<string>('');
  const [isArchiveModalOpen, setIsArchiveModalOpen] = useState<boolean>(false);
  const [placementToArchive, setPlacementToArchive] = useState<Placement | undefined>(undefined);
  const [isDisplayPriorityTakeoverOpen, setIsDisplayPriorityTakeoverOpen] =
    useState<boolean>(false);
  const [displayPriorityTakeoverPlacementId, setDisplayPriorityTakeoverPlacementId] = useState<
    number | undefined
  >(undefined);

  useEffect(() => {
    if (placements?.length) {
      setSelectedPlacement(
        placementId ? placements.find((placement) => placement.id === placementId) : placements[0],
      );
    }
  }, [placements, placementId]);

  const handleArchiveModalOpen = (archiving: Placement) => {
    setIsArchiveModalOpen(true);
    setPlacementToArchive(archiving);
  };

  const handleArchiveModalClose = () => {
    setIsArchiveModalOpen(false);
    setPlacementToArchive(undefined);
  };

  const handleOpenDisplayPriorityTakeover = (
    isOpen: boolean,
    id: number | undefined = undefined,
  ) => {
    setIsDisplayPriorityTakeoverOpen(isOpen);
    setDisplayPriorityTakeoverPlacementId(id);
  };

  const context: PlacementsManageContextState = {
    placements,
    placementsLoading,
    selectedPlacement,
    statusFilterTab,
    searchText,
    placementToArchive,
    isArchiveModalOpen,
    isDisplayPriorityTakeoverOpen,
    displayPriorityTakeoverPlacementId,

    setSelectedPlacement,
    setStatusFilterTab,
    setSearchText,
    openArchiveModal: handleArchiveModalOpen,
    closeArchiveModal: handleArchiveModalClose,
    setIsDisplayPriorityTakeoverOpen: handleOpenDisplayPriorityTakeover,
  };

  return (
    <PlacementsManageContext.Provider value={context}>{children}</PlacementsManageContext.Provider>
  );
};
